import * as React from 'react';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import axios from 'axios';
import AxiosConfig from '../../utilities/AxiosConfig';
import AllowedRoleRow from './AllowedRoleRow';
import Loader from '../common/Loader';
import { qsStringify, exportAsCsv } from '../../utilities/helper';

export interface AllowedRolesProps {
    
}

export type AllowedRoleType = {
    roleName : string,
    target : string,
    key : number,
    description: string | null;
}

export interface AllowedRolesState {
    allowedRoles : Array<AllowedRoleType>,
    loadingRoles : boolean,
    addAllowedRoleOpen : boolean,
    newAllowedRole : AllowedRoleType,
    errorVisible : boolean,
    errorMessage : string,
}

class AllowedRoles extends React.Component<AllowedRolesProps, AllowedRolesState> {
    constructor(props: AllowedRolesProps){
        super(props);
        this.state = {
            allowedRoles : [],
            loadingRoles : true,
            addAllowedRoleOpen : false,
            newAllowedRole : {
                roleName : "",
                target : "",
                key : NaN,
                description: ""
            },
            errorVisible : false,
            errorMessage : "",
        }
    }

    componentDidMount(){
        axios.get(process.env.REACT_APP_API_URL + "/api/portal/allowedrole/*", AxiosConfig.configValue())
        .then(res => {
            //console.log(res);
            this.setState({ allowedRoles : res.data });
        })
        .catch(err => {
            //console.log(err, err.response);
            alert("There was an error getting allowed roles");
            AxiosConfig.handleError(err);
        })
        .finally(() => {
            this.setState({ loadingRoles : false });
        })
    }

    addAllowedRole = (e: React.SyntheticEvent):void => {
        e.preventDefault();
        const { roleName, target } = this.state.newAllowedRole;
        const requestBody = {
            roleName, target 
        }
        axios.post(process.env.REACT_APP_API_URL + '/api/portal/allowedrole',qsStringify(requestBody), AxiosConfig.configValue())
        .then(res => {
            //console.log(res);
            this.setState({ allowedRoles : [...this.state.allowedRoles, this.state.newAllowedRole]})
        })
        .catch(err => {
            //console.log(err, err.response);
            this.setState({ errorVisible : true, errorMessage : err.response.data.Message});
            AxiosConfig.handleError(err);
        })
    }

    changeHandler = (e: React.ChangeEvent<HTMLInputElement>):void => {
        e.preventDefault();
        this.setState({
            newAllowedRole : {
                ...this.state.newAllowedRole,
                [e.target.name] : e.target.value
            }
        })
        //console.log(this.state.newAllowedRole);
    }

    toggleModal = ():void => {
        this.setState({ addAllowedRoleOpen : !this.state.addAllowedRoleOpen });
    }

    deleteRole = (role: AllowedRoleType) => {
        let copy = [...this.state.allowedRoles];
        copy.splice(copy.indexOf(role), 1);
        this.setState({ allowedRoles : copy });
    }

    exportCsv = async() => {
        exportAsCsv(
            ["Name", "Target"], 
            ["RoleName", "Target"], 
            this.state.allowedRoles,
            "allowed_roles",
            );
    }

    editCB = (index: number, edits: AllowedRoleType) => {
        //console.log("Callback for edits.");
        let copy = [...this.state.allowedRoles];
        copy[index] = edits;
        this.setState({ allowedRoles : copy });
        //console.log("new state", copy);
    }

    render() { 
        const { 
            allowedRoles, 
            loadingRoles, 
            addAllowedRoleOpen, 
            newAllowedRole,
            errorVisible,
            errorMessage,
        } = this.state;
        if(loadingRoles){
            return <Loader title="Loading Allowed Roles..." />
        }
        return (
            <>
                <Table striped bordered hover size="sm" responsive="md">
                <thead>
                        <tr>
                            <th>Role Name</th>
                            <th>Target</th>
                            <th className="d-flex flex-row justify-content-end">                 
                                <ButtonGroup className="ml-3">
                                    <Button onClick={this.toggleModal}>
                                        <i className="material-icons flex-0">add</i>
                                    </Button>
                                    <Button variant="info" onClick={this.exportCsv}>
                                        <i className="material-icons flex-0">file_copy</i>
                                    </Button>
                                </ButtonGroup>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            allowedRoles.map((allowedRole: AllowedRoleType, index : number) => <AllowedRoleRow editCB={this.editCB} index={index} deleteCB={() => this.deleteRole(allowedRole)} key={allowedRole.key} role={allowedRole} />)
                        }
                    </tbody>
                </Table>

                <Modal show={addAllowedRoleOpen} onHide={this.toggleModal} className="z-100">
                    <Modal.Header closeButton>
                        <Modal.Title>Add Allowed Role</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {
                        errorVisible && 
                        <Alert variant="danger" onClose={() => this.setState({ errorVisible : false })} dismissible>
                            <p>{errorMessage}</p>
                        </Alert>
                        }
                        <Form>
                            <Form.Group controlId="allowedRolesName">
                                <Form.Label>Role Name</Form.Label>
                                <Form.Control onChange={this.changeHandler} value={newAllowedRole.roleName} type="text" name="roleName" />
                            </Form.Group>
                            <Form.Group controlId="allowedRolesTarget">
                                <Form.Label>Target</Form.Label>
                                <Form.Control onChange={this.changeHandler} value={newAllowedRole.target} type="text" name="target" />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.toggleModal}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={this.addAllowedRole}>
                            Create Allowed Role
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default AllowedRoles;